import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

// "TEST OUR AGENT" floating hint. Pure UI — the actual AskDD widget
// script is loaded by `AskDDLoader` so dismissing this label can never
// prevent the chatbot from loading.

export default function ChatbotLabel() {
  const [isVisible, setIsVisible] = useState(true);
  const [, setHasInteracted] = useState(false);

  // Check if user has dismissed the label before.
  // Key is versioned (`_v2`) so deploys can roll out a fresh label hint
  // to visitors who previously dismissed by bumping the suffix.
  useEffect(() => {
    const dismissed = localStorage.getItem('chatbot_label_dismissed_v2');
    if (dismissed) {
      setIsVisible(false);
    }
  }, []);

  // Hide label when user interacts with chatbot
  useEffect(() => {
    const handleClick = (e) => {
      // Check if click is on the chatbot widget area
      if (e.target.closest('[class*="dd-chatbot"]') || 
          e.target.closest('[id*="dd-chatbot"]') ||
          e.target.closest('iframe[src*="askdd"]')) {
        setHasInteracted(true);
        setIsVisible(false);
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('chatbot_label_dismissed_v2', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-24 right-6 z-[99] animate-fade-in">
      {/* Label Container */}
      <div className="relative group">
        {/* Main Label */}
        <div className="flex items-center gap-2 bg-[#1A1D21] border-2 border-[#4A90E2] rounded-[2px] px-4 py-2 shadow-lg">
          {/* Pulsing Dot */}
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#4A90E2] opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#4A90E2]"></span>
          </span>
          
          {/* Text */}
          <span className="font-mono text-sm text-white tracking-wider font-bold">
            TEST OUR AGENT
          </span>
          
          {/* Dismiss Button */}
          <button 
            onClick={handleDismiss}
            className="ml-2 text-gray-400 hover:text-white transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
        
        {/* Arrow Pointer */}
        <div className="absolute -bottom-3 right-8 w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-t-[10px] border-t-[#4A90E2]"></div>
        <div className="absolute -bottom-[9px] right-[33px] w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[8px] border-t-[#1A1D21]"></div>
      </div>
    </div>
  );
}
